import { Button, Grid2, Stack, Typography } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { IconMedal } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import ModalityRegister from "../components/ModalityRegister";
import ModalityTableComponent from "../components/ModalityTableComponent";
import { modalityList } from "../services/modality";
import PageHeader from "../components/PageHeader";

const Modality = () => {
  const [open, setOpen] = useState(false);

  const {
    data,
    isLoading,
    isFetching,
    refetch,
  }: {
    data: Array<{
      id: string;
      name: string;
      description: string;
      createdAt: string | Date;
      status: boolean;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["modalityList"],
    queryFn: async () => await modalityList({}),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Modalidades"
          subtitle="Informações gerais das modalidades."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconMedal size={18} />
                <Typography variant="body2">Cadastrar modalidade</Typography>
              </Button>
            </Stack>
          }
        />

        {/* <Grid2 size={12}>
          <IndicatorsCard
            data={[
              {
                id: 1,
                title: "Total",
                value: dataIndicators?.allStudents,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 3 },
              },
              {
                id: 2,
                title: "Novos no mês",
                value: dataIndicators?.studentsByMonth,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 3 },
              },
              {
                id: 3,
                title: "Ausentes no mês",
                value: dataIndicators?.absentStudents,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 3 },
              },
              {
                id: 1,
                title: "Check-in no mês",
                value: dataIndicators?.studentsPresents,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 3 },
              },
            ]}
          />
        </Grid2> */}
        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <ModalityTableComponent
                data={data}
                refetch={() => refetchAll()}
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <ModalityRegister
        open={open}
        onClose={() => setOpen(false)}
        refetch={() => refetchAll()}
      />
    </ContainerLoading>
  );
};

export default Modality;
